<!-- desktop template -->
<div class="navbar desktop" *appIsDesktop>
  <div class="navbar-lane">
    @if (!importQuoteActive) {
      <ul>
        <li class="open-menu nav-icon crm-industrial-font icon-menu" [matMenuTriggerFor]="menu"></li>
      </ul>
    }
    <div id="navbar-branding" [ngClass]="{'hiddenMenu': importQuoteActive}">
      <img id="snapon-logo" src="/assets/images/impactLogo.jpg" alt="IMPACT"/>
    </div>
    @if (!importQuoteActive) {
      <div class="divider">
        @if (navItems.length) {
          <ds-divider vertical="true"></ds-divider>
        }
      </div>
    }
    @if (!importQuoteActive) {
      <div>
        <ul id="navbarMenuItems" class="navbar-menu-items">
          @for (url of navItems; track url) {
            <li [ngClass]="{'active': selectedMenu === url.rootpath}">
              <a id="{{url.label}}" [routerLink]="url.path" class="navbar-url">{{url.label}}</a>
            </li>
          }
        </ul>
        <div id="navbar-right-items" class="navbar-right-items">
          <ul id="navbar-user" class="open-menu" [matMenuTriggerFor]="userMenu">
            <li id="user-icon ">
              <mat-icon class="nav-icon" fontIcon="person"></mat-icon>
            </li>
            <li id="user-text" class="nav-text">{{userName}}</li>
          </ul>
        </div>
      </div>
    }
    <mat-menu #menu="matMenu" class="headerMenu">
      <ng-container *ngTemplateOutlet="menuLinks"></ng-container>
      <ds-divider></ds-divider>
      <a class="industrial-app button" mat-menu-item (click)="openHelpInfo()">
        {{ appStrings.help_label }}
      </a>
    </mat-menu>
    <mat-menu #userMenu="matMenu" class="headerMenu userMenu" yPosition="below" xPosition="before">
      <a class="industrial-app button" mat-menu-item (click)="logout()">
        {{ appStrings.navbar_logout }}
      </a>
    </mat-menu>
  </div>
</div>

<!-- mobile template -->
<div class="navbar mobile" *appIsMobile>
  <div class="navbar-lane">
    <ul>
      <li class="open-menu nav-icon crm-industrial-font icon-menu" [matMenuTriggerFor]="menu"></li>
    </ul>
    <div id="navbar-branding">
      <app-icon id="snapon-logo" [icon]="appIcon"></app-icon>
    </div>
    <mat-menu class="mobile" #menu="matMenu">
      <a class="industrial-app button title" mat-menu-item>
        {{ appStrings.menu }}
        <mat-icon iconPositionEnd><span class="crm-industrial-font icon-remove"></span></mat-icon>
      </a>
      <mat-divider></mat-divider>
      @for (url of navItems; track url) {
        <div >
          <a class="industrial-app" mat-menu-item id="{{url.label}}" [routerLink]="url.path">{{url.label}}</a>
        </div>
      }
      <mat-divider></mat-divider>
      <ng-container *ngTemplateOutlet="menuLinks"></ng-container>
      <mat-divider></mat-divider>
      <a class="industrial-app button" mat-menu-item (click)="logout()">
        {{ appStrings.navbar_logout }}
      </a>
      <a class="industrial-app button" mat-menu-item (click)="openHelpInfo()">
        {{ appStrings.help_label }}
      </a>
      <mat-divider></mat-divider>
    </mat-menu>
    <div class="navbar-right">
      <div id="icon" class="circle-name-icon">{{ mobileUserName }}</div>
    </div>
  </div>
</div>


<!-- common -->
<ng-template #menuLinks>
  <a class="industrial-app" mat-menu-item [href]="urls.B2B" target="_blank">
    {{ appStrings.industrialApp_B2B }}
  </a>
  <a class="industrial-app button" mat-menu-item [href]="urls.RRC" target="_blank">
    {{ appStrings.industrialApp_RRC }}
  </a>
  <a class="industrial-app button" mat-menu-item [href]="urls.SEP" target="_blank">
    {{ appStrings.industrialApp_SEP }}
  </a>
  <a class="industrial-app button" mat-menu-item [href]="urls.trueFit" target="_blank">
    {{ appStrings.industrialApp_trueFit }}
  </a>
  <ds-divider></ds-divider>
  <a class="industrial-app" mat-menu-item [href]="urls.industrialCatalog" target="_blank">
    {{ appStrings.industrialApp_catalog }}
  </a>
  <a class="industrial-app" mat-menu-item [href]="urls.infoResources" target="_blank">
    {{ appStrings.industrialApp_infoResources }}
  </a>
  <a class="industrial-app button" mat-menu-item [href]="urls.accountForm" target="_blank">
    {{ appStrings.industrialApp_accountForm }}
  </a>
  <a class="industrial-app button" mat-menu-item [href]="urls.productCatalog" target="_blank">
    {{ appStrings.industrialApp_productCatalog }}
  </a>
  <a class="industrial-app" mat-menu-item [href]="urls.industrialFlyer" target="_blank">
    {{ appStrings.industrialApp_industrialFlyer }}
  </a>
  <a class="industrial-app button" mat-menu-item [href]="urls.tableau" target="_blank">
    {{ appStrings.industrialApp_tableau }}
  </a>
</ng-template>